import { __rest, __assign } from 'tslib';
import React, { forwardRef, useContext, useMemo } from 'react';
import cn from 'classnames';
import { BaseModal } from '../../../base-modal/esm';
import { ContentMobile } from '../components/content/Component.mobile.js';
import { Controls } from '../components/controls/Component.js';
import { FooterMobile } from '../components/footer/Component.mobile.js';
import { Header } from '../components/header/Component.js';
import { ResponsiveContext } from '../ResponsiveContext.js';
import '../components/content/Component.js';
import '../../../shared/esm';
import '../Context.js';
import '../layout.module-99c460df.js';
import '../components/footer/Component.js';
import '../../../navigation-bar-private/esm';
import '../consts.js';

var styles = {"component":"side-panel__component_19laq","content":"side-panel__content_19laq","mobileContent":"side-panel__mobileContent_19laq"};
require('./mobile.css');

var transitions = {"appear":"side-panel__appear_iusen","enter":"side-panel__enter_iusen","appearActive":"side-panel__appearActive_iusen","enterActive":"side-panel__enterActive_iusen","exit":"side-panel__exit_iusen","exitActive":"side-panel__exitActive_iusen","exitDone":"side-panel__exitDone_iusen"};
require('./transitions.mobile.css');

var SidePanelMobileComponent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, transitionProps = _a.transitionProps, dataTestId = _a.dataTestId, restProps = __rest(_a, ["children", "className", "transitionProps", "dataTestId"]);
    var responsiveContext = useContext(ResponsiveContext);
    var contextValue = useMemo(function () { return ({ size: 500, view: 'mobile', dataTestId: dataTestId }); }, [dataTestId]);
    var renderContent = function () {
        var _a;
        return (React.createElement(BaseModal, __assign({}, restProps, { dataTestId: dataTestId, ref: ref, transitionProps: __assign({ classNames: transitions }, transitionProps), className: cn(className, styles.component), scrollHandler: 'content', contentProps: __assign(__assign({}, restProps.contentProps), { className: cn(styles.content, (_a = restProps.contentProps) === null || _a === void 0 ? void 0 : _a.className) }) }),
            React.createElement("div", { className: styles.mobileContent }, children)));
    };
    var renderWithContext = function () { return (React.createElement(ResponsiveContext.Provider, { value: contextValue }, renderContent())); };
    return responsiveContext ? renderContent() : renderWithContext();
});
var ControlsMobile = Controls;
var SidePanelMobile = Object.assign(SidePanelMobileComponent, {
    Content: ContentMobile,
    Header: Header,
    Footer: FooterMobile,
    Controls: ControlsMobile,
});

export { ContentMobile, ControlsMobile, FooterMobile, Header as HeaderMobile, SidePanelMobileComponent as SidePanelComponentMobile, SidePanelMobile };
